<template>
  <div class="column is-one-third">
    <div class="meeting">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteMeeting(meeting.id)"/>
      <b-switch v-model='meeting.isHidden' class="hide-from-site" @change="handleUpdateMeeting">
        Скрыть с сайта
      </b-switch>
      <b-field label="Дата встречи">
        <el-date-picker
         v-model="date"
         :editable="false"
         @change="datePickerChanged"
         type="datetime"
         placeholder="00:00">
        </el-date-picker>
      </b-field>
      <b-field label="Название">
        <b-input @change="handleUpdateMeeting" v-model="meeting.title"></b-input>
      </b-field>
      <b-field label="Описание">
        <Editor :editorToolbar="customToolbar" v-model="description" :id='"q" + meeting.id'/>
      </b-field>
      <b-field label="Ссылка">
        <b-input @change="handleUpdateMeeting" v-model="meeting.link"></b-input>
      </b-field>
      <div class="columns">
        <div class="column is-one-third">
          <b-switch v-model='meeting.publishLater' class="hide-from-site" @change="handleUpdateMeeting">
            Опубликовать позже
          </b-switch>
        </div>
        <div class="column">
          <el-date-picker class="publish-date is-pulled-right"
            v-model="publishDate"
            :editable="false"
            @change="publishDateChanged"
            type="date"
            placeholder="Дата публикации на сайте">
          </el-date-picker>
        </div>
      </div>
      <span class="link" v-if="meeting.meetingParticipants && meeting.meetingParticipants.length" @click="toggleParticipants">
        Количество заявок: {{ meeting.meetingParticipants.length }}
      </span>
    </div>
    <el-dialog class="webinar-dialog" v-if="meeting.meetingParticipants"
      :visible.sync="dialogVisible"
      >
      <div class="club-members">
        <span class="club-members-count">
          Количество заявок: {{ meeting.meetingParticipants.length}}
        </span>
        <table class="club-members-table">
          <thead>
            <tr>
              <td class="name">Имя</td>
              <td class="lastname">Фамилия</td>
              <td class="email">Email</td>
              <td class="phone">Телефон</td>
              <td class="date">Дата заявки</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="member in meeting.meetingParticipants">
              <td class="name"> {{ member.name }} </td>
              <td class="lastname"> {{ member.lastname }} </td>
              <td class="email"> {{ member.email }} </td>
              <td class="phone"> {{ member.phone }}</td>
              <td class="date"> {{ member.date | filterDate }}</td>
              <td class="delete-member"><img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteMeetingParticipant(member.id)"/></td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'Meeting',
  data () {
    return {
      date: '',
      publishDate: '',
      updateTimer: 0,
      dialogVisible: false,
      customToolbar: [
        ['bold', 'italic', 'underline', 'link']
      ],
      description: ''
    }
  },
  props: {
    meeting: {
      type: Object,
      required: true
    }
  },
  created () {
    this.date = this.meeting.date
    this.publishDate = this.meeting.publishDate
    this.description = this.meeting.description
  },
  methods: {
    ...mapActions(['updateMeeting', 'deleteMeeting', 'deleteMeetingParticipant']),
    handleUpdateMeeting () {
      clearTimeout(this.updateTimer)
      this.updateTimer = setTimeout(() => {
        this.updateMeeting(this.meeting)
      }, 1000)
    },
    datePickerChanged (date) {
      this.meeting.date = new Date(date)
      this.handleUpdateMeeting()
    },
    publishDateChanged (date) {
      this.meeting.publishDate = date
      this.handleUpdateMeeting()
    },
    toggleParticipants () {
      this.dialogVisible = !this.dialogVisible
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  },
  watch: {
    description (val) {
      this.meeting.description = this.description
      this.handleUpdateMeeting()
    }
  },
  components: { Editor }
}
</script>
<style scoped>
.meeting {
  background: #eee;
  padding: 20px;
  position: relative;
}
.el-date-editor {
  width: 100%;
}
.delete-icon {
  top: 10px;
  right: 10px;
}
.hide-from-site {
  display: inline-block;
  margin: 0 0 10px;
}
.publish-date {
  max-width: 150px;
}
.delete-member .delete-icon {
  top: -10px;
  right: -30px;
}
</style>
<style>
.meeting .ql-editor {
  height: 130px;
}
</style>



// WEBPACK FOOTER //
// Meeting.vue?34145653